<template>
    <v-card flat>
        <v-card-title>
            <h4>Формирование отчета по ДН</h4>
        </v-card-title>
        <v-card-text>
            <v-form class="px3">
            <v-select
                :items="inputDnReport.dnYears"
                v-model="selectedItemsDnReport.dnYear"
                label="Год выполнения отчета"
                required
            ></v-select>
            <v-select @change="getDnZones($event)"
                v-model="selectedItemsDnReport.kvartal"
                :items="inputDnReport.kvartals"
                label="Квартал"
            ></v-select>
            <v-select :disabled="selectedItemsDnReport.dnYear === null" @change="buttonDisabled = false"
                item-text="filial"
                item-value="filialid"
                :items="inputDnReport.filials"
                v-model="selectedItemsDnReport.filial"
                label="Филиал ЦЗЛ, проводящий работы по ДН"
            ></v-select>
            <v-btn @click="getDnReport" :disabled="buttonDisabled" block>{{buttonText}}</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: 'dnreport',
  data () {
    return {
      buttonText: 'Сформировать',
      buttonDisabled: true,
      inputDnReport: {filials: [], dnYears: [], kvartals: [{value: 0, text: 'Годовой отчет'},{value: 1, text: 'Первый квартал'}, {value: 2, text: 'Второй квартал'}, {value: 3, text: 'Третий квартал'}, {value: 4, text: 'Четвертый квартал'}]},
      selectedItemsDnReport: {filial: null, dnYear: null, kvartal: null}
    }
  },
  mounted: function () {
    this.getDnYears()
  },
  computed: {
    regions: function() {
      var _this = this
      return this.inputDnReport.filials.find(item => item.filialid === _this.selectedItemsDnReport.filial).subjectids
    }
  },
  components: {
  },
  methods: {
    b64toBlob(b64Data, contentType='', sliceSize=512) {
      const byteCharacters = atob(b64Data)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      const blob = new Blob(byteArrays, {type: contentType})
      return blob
    },
    getDnYears() {
      this.$http.get("api/dnyears").then(res => {
        this.inputDnReport.dnYears = res.body.dn_years
      })
    },
    getDnZones(event) {
      this.$http.get("api/dnzones", {params:{'year': this.selectedItemsDnReport.dnYear, 'kvartal': event}}).then(res => {
        this.inputDnReport.filials = res.body.zonadn
      })
    },
    getDnReport() {
      this.buttonDisabled = true
      this.buttonText = 'Формирование отчета, подождите..'
      this.$http.get("api/dnreport_2025", { params:{'year': this.selectedItemsDnReport.dnYear, 'kvartal': this.selectedItemsDnReport.kvartal, 'regions': this.regions, 'filial': this.selectedItemsDnReport.filial }}).then(res => {
        this.buttonDisabled = false
        this.buttonText = 'Сформировать'
        //const blob = this.b64toBlob(res.body.doc, "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
        //const blob = this.b64toBlob(res.body.doc, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        const blob = this.b64toBlob(res.body.doc, "application/zip")
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        var fileName = 'отчет по дн.zip'
        link.download = fileName  
        link.click()
      }, error => {
          this.buttonDisabled = false
          this.buttonText = 'Не удалось формировать, повтор'
      })
    }
  }
}
</script>